 /* eslint-disable */
import { defineStore } from 'pinia';
import { useFavouritesStore } from './favourites';
import { useRegionsStore } from './regions';
import { useCustomerStore } from './customer';
import { useDatesStore } from './dates';
import { useSocketStore } from './socket';
import _ from 'lodash';
import { applyPatch } from 'rfc6902';

export const useTimedSportStore = defineStore('timed_sport', {
	state: () => ({
		fixtures_by_competition: {},
		competitions_by_time: [],

		time_fixtures: [],
		current_page: 1,
		last_page: 1,
		is_loading: false,
	}),
	getters: {
		isAllFixturesByCompetitionOutrights: (state) => {
			for (const competition_id in state.fixtures_by_competition) {
				const competition = state.fixtures_by_competition[competition_id];
				let is_outright = _.every(competition, fixture => fixture.outright);
				if(!is_outright) {
					return false;
				}
			}

			return true;
		},
		isAllTimeFixturesOutrights: (state) => {
			let is_outright = _.every(state.time_fixtures, fixture => fixture.outright);
			if(!is_outright) {
				return false;
			}

			return true;
		},
	},
	actions: {
		async fetchRegionsByTime(sport_id, time) {
			const customerStore = useCustomerStore();
			const payload = {
				sport_id: sport_id,
				from: time,
				utc_offset: customerStore.getCustomersUtcOffset
			}

			if (time == 'all') {
				if (useRegionsStore().regions_competitions_all == null) {
					console.log('fetching')
					await useRegionsStore().fetchRegions(sport_id);
					console.log('fetched')
				}

				console.log('useRegionsStore.regions_competitions_all', useRegionsStore().regions_competitions_all)
				this.addCompetitionsByTime(useRegionsStore().regions_competitions_all);
				return Promise.resolve(useRegionsStore().regions_competitions_all);
			}

			return global.axios.get(process.env.VUE_APP_SPORTSBOOK_API_URL + '/sport/' + sport_id + '/competitions-per-region', { params: payload }).then((response) => {
				if (response.data.regions) {

					this.addCompetitionsByTime(response.data.regions);
					return Promise.resolve(response.data);
				}
			}).catch((error) => {
				console.log(error);
				return Promise.reject(error)
			});
		},
		addCompetitionsByTime(regions) {
			let competitions = [];
			for (const region_id in regions) {
				const region = regions[region_id];
				const region_all = useRegionsStore().regions_competitions_all?.find(region => region.id === region_id);


				for (const competition_id in region.competitions) {
					const competition = region.competitions[competition_id];

					// Find competition from regions competitions all
					if (region_all) {
						const competition_all = region_all?.competitions[competition_id];
						competition.weight = competition_all?.weight;
					}

					competition.region_name = region.name
					competition.region_icon_url = region.icon;
					competitions.push(competition);
				}
			}

			this.competitions_by_time = _.orderBy(competitions, 'weight', 'desc');
		},

		async fetchFixturesByCompetitionByTime(sport_id, competition_id, time, pre_only = false) {

			if (this.fixtures_by_competition[competition_id]) {
				return Promise.resolve(this.fixtures_by_competition[competition_id]);
			}

			const customerStore = useCustomerStore();
			const payload = {
				sport_id: sport_id,
				competition_ids: competition_id,
				from: time,
				utc_offset: customerStore.getCustomersUtcOffset,
				pre_only: pre_only ? 1 : 0
			}

			if (time == 'all') {
				delete payload.from;
			}

			return global.axios.get(process.env.VUE_APP_SPORTSBOOK_API_URL + '/sport/' + sport_id + '/upcoming-events', { params: payload }).then((response) => {
				this.setFixturesByCompetition(response.data);
				this.getLiveFixturesAndJoin(response.data);

				return Promise.resolve(response.data);
			}).catch((error) => {
				console.log(error)
				return Promise.reject(error);
			})
		},
		getLiveFixturesAndJoin(payload) {
			const socketStore = useSocketStore();
			for (const fixture_data of payload) {
				for (const fixture_id in fixture_data.fixtures) {
					const fixture = fixture_data.fixtures[fixture_id];
					if (fixture.live) socketStore.join('favouriteFixture', fixture_id);
				}
			}
		},
		leaveLiveFavouriteFixtures(competition_id) {
			const socketStore = useSocketStore();

			for (const fixture_id in this.fixtures_by_competition[competition_id]) {
				const fixture = this.fixtures_by_competition[competition_id][fixture_id];
				if (fixture.live) socketStore.leave('favouriteFixture', fixture_id);
			}
		},
		leaveTimeFixtures() {
			const socketStore = useSocketStore();
			for (const fixture_data of this.time_fixtures) {
				if (fixture_data.live) socketStore.leave('favouriteFixture', fixture_data.id);
			}
		},
		updateFavouriteFixture(data) {
			this.updateFixturesByCompetition(data);
			this.updateFixturesTimeFixtures(data);
		},
		deleteFavouriteFixture(data) {
			this.deleteFixturesByCompetition(data);
			this.deleteFixturesTimeFixtures(data);
		},
		deleteFixturesTimeFixtures(data) {
			let index = this.time_fixtures.findIndex(fixture => fixture.id === data);
			if (index !== -1) {
				this.time_fixtures.splice(index, 1);
			}
		},
		deleteFixturesByCompetition(data) {
			for (const key in this.fixtures_by_competition) {
				if (!Object.hasOwn(this.fixtures_by_competition, key)) continue;

				let fixture_data = this.fixtures_by_competition[key];

				for (const fixture_id in fixture_data) {
					if (fixture_id == data) {
						delete this.fixtures_by_competition[key][fixture_id];
						return;
					}
				}
			}
		},
		updateFixturesTimeFixtures(data) {
			// need to find index
			let index = this.time_fixtures.findIndex(fixture => fixture.id === data.id);
			if (index !== -1) {
				applyPatch(this.time_fixtures[index], data.patch);
			}
		},
		updateFixturesByCompetition(data) {
			for (const key in this.fixtures_by_competition) {
				if (!Object.hasOwn(this.fixtures_by_competition, key)) continue;

				let fixture_data = this.fixtures_by_competition[key];

				for (const fixture_id in fixture_data) {
					if (fixture_id == data.id) {
						applyPatch(this.fixtures_by_competition[key][fixture_id], data.patch);
						// break all loops
						return;
					}
				}
			}
		},

		async fetchTimeFixtures(sport_id, time, is_next_page = false, competition_ids = null, pre_only = false) {
			if (this.is_loading) return;

			if (!is_next_page) this.current_page = 1;

			this.is_loading = true;

			const customerStore = useCustomerStore();

			let payload = {
				utc_offset: customerStore.getCustomersUtcOffset,
				page: this.current_page,
				from: time,
				pre_only: pre_only ? 1 : 0
			}

			if (time == 'all') {
				delete payload.from;
			}
			if (competition_ids) {
				payload.competition_ids = competition_ids;
			}

			return global.axios.get(process.env.VUE_APP_SPORTSBOOK_API_URL + '/sport/' + sport_id + '/upcoming-paginated', { params: payload }).then((response) => {
				const dates_store = useDatesStore();
				const socketStore = useSocketStore();

		        for (const key in response.data.data) {
					const fixture = response.data.data[key];

					if (fixture.live) socketStore.join('favouriteFixture', fixture.id);
				}

				const processed_fixtures = response.data.data.map(fixture => ({
					...fixture,
					formatted_date: dates_store.competitionFixtureDate(fixture.start_datetime)
				}));

				if (is_next_page) this.time_fixtures = [...this.time_fixtures, ...processed_fixtures];
				else this.time_fixtures = processed_fixtures;

				this.current_page = response.data.meta.page;
				this.last_page = response.data.meta.total_pages;

				return Promise.resolve(response.data);
			}).catch((error) => {
				console.log(error)
				return Promise.reject(error);
			}).finally(() => {
				this.is_loading = false;
			})

		},
		loadMoreFixtures(sport_id, time, competition_ids = null, pre_only = false) {
			if (this.current_page < this.last_page && !this.is_loading) {
				this.current_page++;
				return this.fetchTimeFixtures(sport_id, time, true, competition_ids, pre_only);
			}
		},
		setFixturesByCompetition(payload) {
			// array of objects
			payload.forEach(fixture_data => {
				this.fixtures_by_competition[fixture_data.competition_id] = fixture_data.fixtures;
			});
		},
		clearCompetitionsByTime() {
			this.competitions_by_time = [];
			this.fixtures_by_competition = {};
		}
	}
})